import { useState as e } from "react";
const B = 0;
function L(l, r, o, u, t) {
  const [h, c] = e(!1), n = h ? o : u, [g, C] = e(n ? n.length : B), [f, a] = e(!1);
  return {
    valueCounter: g,
    isOnBlur: f,
    hasLabelOrHelperText: !!(l ?? r),
    onBlur: () => {
      a(!0);
    },
    handleChange: (s) => {
      c(!0), C(s.target.value.length), t && t(s), a(!1);
    }
  };
}
export {
  L as useTextarea
};
